import { missingDetailsOf } from '../../domain/services/missingDetails';
import { watchHeldItems } from '../../infrastructure/api/billingItemApi';
import { useLatestWatch } from './useLatestWatch';

/**
 * The fields a client's held items say are missing, for one hold reason, followed while the task
 * is shown, so a partial fix drops what it filled in. Empty while it reads, or when nothing could be
 * read; the card then says what is wrong in general.
 *
 * @param {() => {clinicId: string|null, clientId: string|null, holdReason: string}|null} subject
 */
// eslint-disable-next-line import/prefer-default-export
export function useMissingDetails(subject) {
  const { value: missing, reading } = useLatestWatch(
    () => {
      const current = subject();

      return current?.clinicId && current?.clientId
        ? { clinicId: current.clinicId, clientId: current.clientId, holdReason: current.holdReason }
        : null;
    },
    (params, onValue, onError) => watchHeldItems(params, (items) => onValue(missingDetailsOf(items)), onError),
    { initial: [], label: 'what a client\'s held items are missing' },
  );

  return { missing, reading };
} // useMissingDetails()
